export default __webpack_public_path__ + "static/mobilefuse-6fd6e7769659608c147ee829eb79a2f9.png";